import { Footer } from "@data-products-and-ai/react-components";
import { useLocation } from "react-router-dom";

type Links = {
  url: string;
  title: string;
  target?: "_self" | "_blank";
};

const FooterWrapper = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const template =
    (queryParams.get("template") as "tableau" | "web" | undefined) || "tableau";

  const language = queryParams.get("language") as string | undefined;
  const lastUpdate = queryParams.get("lastUpdate") as string | undefined;
  const area = queryParams.get("area") as string | undefined;
  const published = queryParams.get("published") as string | undefined;

  const background =
    (queryParams.get("background") as "light" | "dark" | undefined) || "light";
  const showCopyright =
    JSON.parse(queryParams.get("showCopyright") as string) || undefined;
  const showRestricted =
    JSON.parse(queryParams.get("showRestricted") as string) || undefined;
  const appName = queryParams.get("appName") as string | undefined;
  const appVersion = queryParams.get("appVersion") as string | undefined;
  const links =
    (JSON.parse(queryParams.get("links") as string) as Links[]) || undefined;
  const infoLink = queryParams.get("infoLink") as string | undefined;

  return (
    <>
      <div style={{ padding: template === "tableau" ? 10 : 0 }}>
        <Footer
          template={template}
          language={language}
          area={area}
          lastUpdate={lastUpdate}
          published={published}
          infoLink={infoLink}
          background={background}
          showCopyright={showCopyright}
          showRestricted={showRestricted}
          appName={appName}
          appVersion={appVersion}
          links={links}
        />
      </div>
    </>
  );
};

export default FooterWrapper;
